import React, { useState, useEffect } from "react";
import { TextField, Button, Snackbar } from "@mui/material";
import useUserStore from "../../Stores/userStore";
import "./login.css";
import { useHistory } from "react-router-dom/cjs/react-router-dom";

function LoginViewComponent() {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [isRegister, setIsRegister] = useState(false);
  const [open, setOpen] = useState(false);
  const history = useHistory()
  const setUserData = useUserStore((state) => state.setUser);

  const sendLogin = (loginEmail, loginPassword) => {
    const loginBody = {
      email: loginEmail,
      password: loginPassword,
    };
    let fetchData = {
      method: "POST",
      body: JSON.stringify(loginBody),
      headers: new Headers({
        "Content-Type": "application/json; charset=UTF-8",
      }),
    };
    fetch(
      "https://grupo-serdan-back-iplv-dev.fl0.io/api/users/login",
      fetchData
    )
      .then((res) => {
        return res.json();
      })
      .then((res) => {
        if (res.token) {
          setUserData(res);
          history.push('/resumen')
        }
      });
    // localhost:8080/api/
  };

  const sendRegister = () => {
    const loginBody = {
      email,
      password,
    };
    let fetchData = {
      method: "POST",
      body: JSON.stringify(loginBody),
      headers: new Headers({
        "Content-Type": "application/json; charset=UTF-8",
      }),
    };
    fetch("https://grupo-serdan-back-iplv-dev.fl0.io/api/users", fetchData)
      .then((res) => {
        return res.json();
      })
      .then((res) => {
        setOpen(true)
        sendLogin(res.email, res.password)

      });
  };

  useEffect(() => {
    setEmail("");
    setPassword("");
    setConfirmPassword("");
  }, [isRegister]);

  const loginInputs = (
    <div>
      <TextField
        variant="outlined"
        fullWidth
        placeholder="Email"
        className="mb-2"
        value={email}
        onChange={(e) => setEmail(e.target.value)}
      />
      <TextField
        variant="outlined"
        fullWidth
        placeholder="Contraseña"
        className="mb-2"
        value={password}
        onChange={(e) => setPassword(e.target.value)}
        type="password"
      />
    </div>
  );

  const registerInputs = (
    <div>
      <TextField
        variant="outlined"
        fullWidth
        placeholder="Email"
        className="mb-2"
        value={email}
        onChange={(e) => setEmail(e.target.value)}
      />
      <TextField
        variant="outlined"
        fullWidth
        placeholder="Contraseña"
        className="mb-2"
        value={password}
        onChange={(e) => setPassword(e.target.value)}
        type="password"
      />
      <TextField
        variant="outlined"
        fullWidth
        placeholder="Repite Contraseña"
        className="mb-2"
        value={confirmPassword}
        onChange={(e) => setConfirmPassword(e.target.value)}
        type="password"
      />
    </div>
  );

  const handleClose = (event, reason) => {
    if (reason === 'clickaway') {
      return;
    }

    setOpen(false);
  };

  return (
    <div className="login-container">
      <Snackbar
        open={open}
        autoHideDuration={1000}
        onClose={handleClose}
        message="Usuario creado con éxito"
      ></Snackbar>
      <div className="login-form-container">
        <p className="mb-2">
          <b>{isRegister ? "Registro" : "Iniciar Sesión"}</b>
        </p>
        {isRegister ? registerInputs : loginInputs}
        <div className="button-container" style={{ width: "100%" }}>
          <Button
            className="register-button"
            type="submit"
            variant="contained"
            onClick={() => setIsRegister(!isRegister)}
          >
            {isRegister ? "Iniciar sesión" : "Registrarme"}
          </Button>
          <Button
            type="submit"
            variant="contained"
            style={{ marginLeft: "auto" }}
            onClick={() => {isRegister ? sendRegister() : sendLogin(email, password)}}
          >
            Enviar
          </Button>
        </div>
      </div>
    </div>
  );
}

export default LoginViewComponent;
